import { resizeMascotImage } from '@maxpreps/shared/functions/utils/resizeImage';
import React from 'react';
import PhotoOrInitial, { IPhotoOrInitialProps } from './PhotoOrInitial';

interface IMascotProps
  extends Omit<IPhotoOrInitialProps, 'alt' | 'fallbackLetter'> {
  name: string;
}

const Mascot: React.FC<IMascotProps> = ({ src, name, size = 40, ...props }) => (
  <PhotoOrInitial
    src={resizeMascotImage(src ?? '', null, size, size)}
    alt={name}
    fallbackLetter={name}
    size={size}
    {...props}
  />
);

export default Mascot;
